<script lang="ts">
import { defineComponent, h } from "vue";
import type { DefineComponent, PropType, VNodeProps } from "vue";

import type {
  DsComponentRenderProp,
  DsComponentRenderSlot,
} from "./DsComponentRender.types";

export default defineComponent({
  name: "DsComponentRender",
  props: {
    component: {
      type: Object as PropType<DsComponentRenderProp>,
      required: true,
    },
  },
  setup(props) {
    return () =>
      h(
        props.component.name as DefineComponent,
        props.component.attributes as VNodeProps,
        props.component.slots as DsComponentRenderSlot
      );
  },
});
</script>
